import React from "react";

/**
 * Animated scroll indicator for hero sections
 */
const ScrollIndicator = ({ className = "" }) => {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <span className="text-sm text-white/70 mb-2 font-light tracking-wider">
        Scroll
      </span>
      <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
        <div className="w-1.5 h-3 bg-white/70 rounded-full animate-scroll-bounce" />
      </div>
    </div>
  );
};

export default ScrollIndicator;
